import {FiRefreshCcw} from 'react-icons/fi';

import {useSelector} from 'react-redux';
import IconBtn from '../../elements/IconBtn';
import UseSetParams from './UseSetParams';

const DeleteFilterTable = () => {
    const filter = useSelector((state) => state.TableRedux.filter);
    const [, handleDeleteParams] = UseSetParams();
    return (< >
        {Object.values(filter).length !== 0 &&
            // filter.constructor === Object &&


            <IconBtn color='redIconBtn' TooltipText='حذف فیلترها'
                     onClick={handleDeleteParams}>
                <FiRefreshCcw size={17}/>

            </IconBtn>


        }
    </>);
};

export default DeleteFilterTable;